import React, { useState } from 'react';
import { sendAsesoriaContact } from '../../api/service';

function Advice() {
    const [formData, setFormData] = useState({
        nombre: '',
        apellido: '',
        correo: '',
        mensaje: ''
    });
    const [status, setStatus] = useState('idle'); // idle, loading, success, error
    const [errorMessage, setErrorMessage] = useState('');

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('loading');
        setErrorMessage('');
        try {
            await sendAsesoriaContact(formData);
            setStatus('success');
            setFormData({ nombre: '', apellido: '', correo: '', mensaje: '' });
        } catch (error) {
            setStatus('error');
            setErrorMessage('Hubo un error al enviar el formulario. Por favor, inténtelo de nuevo más tarde.');
            console.error(error);
        }
    };

    return (
        <>
            <section className="tittle-advice">
                <div className="tittle-adv-left">
                    <div className="titt-adv">
                        <span>Asesorías</span>
                    </div>
                    <div className="div-advice">
                        <i className="ri-empathize-fill publ-icon"></i>
                        <span>Apoyo constante</span>
                    </div>
                </div>
            </section>

            <section className="sec-advice">
                <div className="block-info-adv font-n">
                    <h3 className="adv-subtitle">Impulsa tu desarrollo con apoyo personalizado</h3>
                    <p className="adv-text">
                        Entendemos que cada proyecto y proceso de aprendizaje es único. Por eso, te ofrecemos un espacio adaptado a tus necesidades reales. Ya sea que busques resolver dudas técnicas, destrabar un proyecto o fortalecer tus habilidades, estamos aquí para guiarte.
                    </p>

                    <div className="adv-contact-box">
                        <div className="block-adv">
                            <h4 className="adv-form-title">Escríbenos</h4>
                            <p>
                                ¿Listo para avanzar? Contáctanos y cuéntanos qué necesitas:
                            </p>
                            
                            {status === 'success' ? (
                                <div className="adv-alert adv-alert-success">
                                    ¡Gracias por tu consulta! Nos pondremos en contacto contigo a la brevedad.
                                </div>
                            ) : (
                                <form onSubmit={handleSubmit} className="adv-form">
                                    {status === 'error' && (
                                        <div className="adv-alert adv-alert-error">{errorMessage}</div>
                                    )}

                                    <div className="adv-form-layout">
                                        {/* COLUMNA IZQUIERDA */}
                                        <div className="adv-left-col">
                                            <div className="adv-row-inputs">
                                                <input
                                                    type="text"
                                                    className="adv-input"
                                                    placeholder="Nombre"
                                                    name="nombre"
                                                    value={formData.nombre}
                                                    onChange={handleChange}
                                                    required
                                                />
                                                <input
                                                    type="text"
                                                    className="adv-input"
                                                    placeholder="Apellido"
                                                    name="apellido"
                                                    value={formData.apellido}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                            <input
                                                type="email"
                                                className="adv-input"
                                                placeholder="Correo electrónico"
                                                name="correo"
                                                value={formData.correo}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>

                                        {/* COLUMNA DERECHA */}
                                        <div className="adv-right-col">
                                            <textarea
                                                className="adv-textarea"
                                                placeholder="¿En qué podemos ayudarte o qué tipo de asesoría necesitas?"
                                                name="mensaje"
                                                value={formData.mensaje}
                                                onChange={handleChange}
                                                required
                                            ></textarea>
                                            <button
                                                type="submit"
                                                className="adv-btn-submit"
                                                disabled={status === 'loading'}
                                            >
                                                <span>{status === 'loading' ? 'Enviando...' : 'Enviar consulta'}</span>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Advice;